import { gql } from "apollo-boost";
import { useCallback } from "react";
import { useAppState } from "../contexts/AppContext";
import { useLazyQuery } from "@apollo/react-hooks";

export const TRIAL_DAYS = 30;

const useStripePlans = () => {
    const [, setAppState] = useAppState();

    const [loadPlans] = useLazyQuery<GetStripePlan>(GET_PLANS);

    const getPlans = useCallback((countryCode: string = "") => {
        return loadPlans({
            variables: {
                countryCode
            }
        }).then(res => {
            const plans = res?.data?.getStripePlans || [];
            setAppState((prevState: any) => {
                const prevPlan = prevState.selectedPlan;

                return {
                    plans,
                    selectedPlan: prevPlan ? plans.find((plan: StripePlan) => plan.Interval === prevPlan.Interval) : plans[0],
                    selectedCountry: countryCode ?
                        prevState.countryCodes.find((country: CountryCode) => country.code.toUpperCase() === countryCode.toUpperCase()) :
                        prevState.selectedCountry
                }
            });
        })
    }, [loadPlans, setAppState])

    return {
        getPlans
    };
};

const GET_PLANS = gql`
    query getStripePlans($countryCode: String) {
        getStripePlans(countryCode: $countryCode) {
            id
            Currency
            NiceCurrency
            CountryCode
            Interval
            Tiers {
                id
                UnitAmount
                UpTo
            }
        }
    }
`;

export default useStripePlans;
